import { Component, OnInit, Input, Output, EventEmitter, OnChanges, SimpleChanges, SimpleChange } from '@angular/core';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { BehaviorSubject } from 'rxjs/Rx'
import { ErpApiService } from '../../../services/erp-api.service';
import { ScriptLoaderService } from '../../../_services/script-loader.service';
import {LocalStorageService, SessionStorageService} from "ngx-webstorage";
import { MENU_TEXT_TH , MENU_TEXT_EN } from '../../../mokup/menu';
import { LABEL_EN,LABEL_TH } from '../../../mokup/label';

declare let jQuery :any;

declare let swal;

@Component({
  selector: 'app-master-form',
  templateUrl: './master-form.component.html',
  styles: []
})
export class MasterFormComponent implements OnInit {

  @Output('saved') saved = new EventEmitter()
  @Output() submit = new EventEmitter()
  @Output() formChange = new EventEmitter()
  @Output() onDataChanged = new EventEmitter()

  @Input() idName = 'id'

  menu = {}
  textLabel = {}

  public value_ = new BehaviorSubject([]);
  @Input()
  set value(value) {
    this.value_.next(value);
  }
  get value() {

    return this.value_.getValue();
  }

  // _value = new BehaviorSubject([]);
  // @Input()
  // set value(value) {
  //   this._value.next(value);
  // };

  // get value() {

  //   return this._value.getValue();
  // }


  _dataId: any;
  @Input() form: any = {}
  @Input() display :any = {}

  $params = {}
  $app = {
    alert: {
      warning: function(title, text = ''){
        swal(title, text, "warning")
      },
      confirm(title = 'ยืนยันการดำเนินการ', text = ''){

        return new Promise((resolve, reject) => {

          swal({
              title: title,
              text: text,
              type: 'warning',
              showCancelButton: true,
              confirmButtonText: 'ยืนยัน',
              cancelButtonText: 'ยกเลิก',
              reverseButtons: true
          }).then(function(result){
              if (result.value) {

                resolve()
              } else if (result.dismiss === 'cancel') {

                // reject()
              }
          })
        })
      }
    },
    settings: {
      imagePath: 'http://103.253.72.142:7000/api/upload/getfile/'
    },
    imageUrl(imageId){

      return this.settings.imagePath + imageId
    }
  }

  @Input() set dataId(id: any){

    this._dataId = id

    if(id){
      this.loadDataById(id)
    }
  }
  get dataId(){

    return this._dataId
  }

  constructor(
    protected ERPAPI: ErpApiService,
    protected _script: ScriptLoaderService,
    protected router: Router,
    protected route: ActivatedRoute,
    protected localSt:LocalStorageService, 
    protected sessionSt:SessionStorageService,
    
  ) {

    this.route.params.forEach(params => {
      this.$params = params
    })

    setTimeout(() => {

      this.formChange.emit(this.form)
    }, .1);

    this.router.events.subscribe((evt) => {
      if (!(evt instanceof NavigationEnd)) {
          return;
      }
      window.scrollTo(0, 0)
    })

    this.value_.subscribe(value => {

      this.onValueChange(value)
    });
  }

  onValueChange(value){}
  $initForm(data = {}){
    this.form = data
  }
  async insert(params = null) {}
  async update(id, params = null) {}
  async delete(id) {}


  ngOnInit() {
    this.form = this.form || {}
    this.route.params.forEach(params => {
      this.$params = params
    })

    this.router.events.subscribe((evt) => {
      if (!(evt instanceof NavigationEnd)) {
          return;
      }
      window.scrollTo(0, 0)
  });
}
ngAfterViewInit(){
  this.route.params.forEach(params => {
    this.$params = params
  })

  this.router.events.subscribe((evt) => {
    if (!(evt instanceof NavigationEnd)) {
        return;
    }
    window.scrollTo(0, 0)
});
}

  loadDataById(id){
    
    this.fetchFormData(id).then(data => {
      this.form = data || {}
    }).catch(res => {

      this.$app.alert.warning('ไม่พบข้อมูล')
      this.router.navigate(['/'], { replaceUrl: true })
    })
  }

  getForm(){

    return this.$getForm()
  }

  $getForm(){
    return JSON.parse(JSON.stringify(this.form))
  }

  fetchFormData(id){

    return Promise.resolve({})
  }

  save(data){
    
    this.$save(data)
  }

  async $save(data){

    let res
    if(data[this.idName]){
      
      res = await this.edit(data[this.idName], data)
    } else {
      res = await this.add(data)
    }
    this.saved.emit(res)
    return res
  }

  add(data){
    
    return this.insert().then(data => {
      this.ngOnInit()
      this.onDataChanged.emit()
      return data
    }).catch(ex => {

      this.$app.alert.warning(ex.message)
    })
  }

  edit(id, data){
    
    return this.update(id).then(data => {
      this.ngOnInit()
      this.onDataChanged.emit()
      return data
    }).catch(ex => {

      this.$app.alert.warning(ex.message)
    })
  }

  $delete(id){

    return this.delete(id).then(data => {
      this.ngOnInit()
      this.onDataChanged.emit()
      return data
    }).catch(ex => {

      this.$app.alert.warning(ex.message)
    })
  }

  initLoadPage(){
    //page preloader
	jQuery(".preloaderimg").fadeOut();
	jQuery(".preloader").delay(400).fadeOut("slow").delay(400, function(){
		jQuery(this).remove();
	});
  }

  changeLanguage(){
    // console.log(this.localSt.retrieve('language'));
    if(this.localSt.retrieve('language') == 'EN' || this.localSt.retrieve('language') == '' || this.localSt.retrieve('language') == null){
      return true;
    }else{
      return false;
    }
  }
 
  setLocalStorage(name,value){
    this.localSt.store(name,value);
  }
  
  setLocalStorageLanguage(name,value){
    this.localSt.store(name,value);
    window.location.reload(true);
	}

	getLocalStorage(name){
		alert(this.localSt.retrieve(name));
	}

	deleteLocalStorage(name){
		this.localSt.clear(name);
  }
  
  fetchMenu(){
    let languageEN = this.changeLanguage();
    if (languageEN) {
      this.menu = MENU_TEXT_EN;
    }else{
      this.menu = MENU_TEXT_TH;
    }
    return this.menu;
  }
  loadTextLabel(){
    let languageEN = this.changeLanguage();
    if (languageEN) {
      this.textLabel = LABEL_EN;
    }else{
      this.textLabel = LABEL_TH;
    }
    return this.textLabel;
  }

}



// WEBPACK FOOTER //
// ./src/app/components/form/master-form/master-form.component.ts